import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavItem } from 'react-bootstrap';
import { withRouter, Redirect, Switch, Route } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';

import ProgressBar from '../../../../components/progress-bar';
import EmailAlertDetailPage from './EmailAlertDetailPage';

import {
  getUserCurrentOrganization,
} from '../../../Auth/AuthReducer';

import {
  fetchEmailAlerts,
} from '../../SetupActions';

class EmailAlertsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    const { _id } = this.props.organization;
    this.props.dispatch(fetchEmailAlerts(_id)).then(
      (_response) => {
        this.setState({ loading: false });
      },
      (_error) => {
        this.setState({ loading: false });
        const el = (<div>Email alert fetch failed</div>);
        this.context.addNotification(el, {
          type: 'error',
          autoClose: true,
        });
      },
    );
  }

  renderTabs() {
    const { location: { pathname } } = this.props;

    const components = [
      {
        uri: 'buyer-feedback',
        label: 'Buyer Feedback',
        props: {
          type: 'buyerFeedback',
          label: 'Buyer Feedback',
          title: 'Buyer Feedback Email Digest',
          subtitle: 'Provides a summary of recent buyer feedback and recently closed opportunities with no feedback requests for a user based on opportunity ownership.',
        },
      },
      {
        uri: 'missing-feedback',
        label: 'Missing Feedback',
        props: {
          type: 'missingFeedback',
          label: 'Missing Feedback',
          title: 'Missing Feedback Email Digest for Managers',
          subtitle: 'Provides a summary of sales reps that are not requesting feedback for their recently closed opportunities based on their sales teams.',
          enableRecipients: true,
        },
      },
    ];

    return (
      <div>
        <div className="clearfix">
          <div className="pull-left" style={{ marginBottom: '16px' }}>
            <ul className="nav nav-tabs">
              {components.map(component => (
                <LinkContainer key={component.uri} to={`/setup/email-alerts/${component.uri}`}>
                  <NavItem>{component.label}</NavItem>
                </LinkContainer>
              ))}
            </ul>
          </div>
        </div>
        {(pathname === '/setup/email-alerts' && <Redirect to="/setup/email-alerts/buyer-feedback" />)}
        <Switch>
          {components.map((component) => {
            return (
              <Route
                key={component.uri}
                path={`/setup/email-alerts/${component.uri}`}
                render={(props) => {
                  return (
                    <EmailAlertDetailPage
                      {...component.props}
                      {...props}
                    />
                  );
                }}
              />
            );
          })}
        </Switch>
      </div>
    );
  }

  render() {
    const { loading } = this.state;
    return (
      <div className="container">
        <div className="well">
          Control which email alerts are enabled, their frequency, and who the alerts are sent to.
        </div>
        {loading && <ProgressBar />}
        {!loading && this.renderTabs()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

EmailAlertsPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
};
EmailAlertsPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps)(EmailAlertsPage));
